import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Reports from './components/reports';
import NotFound from './components/errors/NotFound';
import Unauthenticated from './components/errors/Unauthenticated';

const App: React.FC = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Routes>
        <Route path="/reports" element={<Reports />} />
        <Route path="/" element={<Navigate to="/reports" replace />} />
        <Route path="/unauthenticated" element={<Unauthenticated />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default App;